<div class="cancel">
    <div class="modal-header px-0 pb-0">
        <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.RequestFormPage,
            langText.LocationSetupIncomplete)}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
    </div>
    <div class="modal-body pb-0">
        <p>{{localize(langSection.RequestFormPage, langText.LocationIncomplete)}} {{slicName}} {{localize(langSection.RequestFormPage,
            langText.LocationSetupIncompleteMessage)}}</p>
    </div>
    <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-green" (click)="goBack()">Close</button>
    </div>
</div>